/**
 * Чек-лист открытия города (BLUEPRINT Stage 14, задача 1).
 *
 * Из анализа рынка: второй город не открывают, пока не отработан шаблон первого — поэтому
 * пункт «первый город довёл ≥ 4 отрядов до 4-го сбора» есть в списке, но он **предупреждение,
 * а не блок**: решение открывать город принимает владелец, софт только показывает состояние.
 */

export const CITY_LAUNCH = {
  /** Сколько районов нужно завести до открытия набора */
  minDistricts: 4,
  /** Сколько площадок нужно завести */
  minVenues: 2,
  /** Сколько основных активностей должно быть в каталоге города */
  minPrimaryActivities: 1,
  /** Сколько шаблонов сезона должно быть заведено (общие на все города) */
  minTemplates: 1,
  /** Отрядов в уже открытом городе, доживших до этого сбора, — условие «шаблон отработан» */
  provenSquads: 4,
  provenGatheringIndex: 4,
} as const;

export type CityLaunchConstants = typeof CITY_LAUNCH;

/** Пункты чек-листа в порядке показа. */
export const CITY_LAUNCH_STEPS = [
  'districts',
  'venues',
  'activities',
  'templates',
  'pricing',
  'operator',
  'proven',
] as const;
export type CityLaunchStep = (typeof CITY_LAUNCH_STEPS)[number];

/** Пункты-предупреждения: не проходят — открыть город всё равно можно. */
export const CITY_LAUNCH_SOFT_STEPS: readonly CityLaunchStep[] = ['proven', 'operator'];

export function isSoftLaunchStep(step: CityLaunchStep): boolean {
  return CITY_LAUNCH_SOFT_STEPS.includes(step);
}
